import { PreTextDisplay } from '../../../../components/Util/PreTextDisplay';
import { BaseCard } from '@cks-internal/react-base';
import { PropsWithChildren } from 'react';

type Props = {
  header: string;
  renderIfEmpty?: boolean;
  htmlText?: string | undefined;
};
/**
 * ActivityInformationBox component renders a policy or note section inside a subtle card layout.
 *
 * It checks for provided HTML text or children and returns nothing if both are absent (unless overridden).
 *
 * @component
 * @param {{
 *   header: string;            // Title to display at the top of the card
 *   renderIfEmpty?: boolean;   // If true, renders an empty card even when no content is provided
 *   htmlText?: string;         // Raw HTML string to dangerously set inside the card body
 * }} props
 * @param {React.ReactNode} [props.children]
 * @returns {JSX.Element|null}
 */
export const ActivityInformationBox = (props: Props & PropsWithChildren) => {
  if ((!props.htmlText || props.htmlText == '') && !props.children) {
    return <></>;
  }
  return (
    <BaseCard variant={'subtle'} size={'sm'} header={props.header} minW={'25%'} display={'inline-block'} w={'100%'}>
      <PreTextDisplay>
        {props.htmlText && <span dangerouslySetInnerHTML={{ __html: props.htmlText }}></span>}
        {props.children}
      </PreTextDisplay>
    </BaseCard>
  );
};
